import {
  PLANS_AND_SERVICES_BENEFITS_FILTER_RESET,
  PLANS_AND_SERVICES_BENEFITS_SERVICES_FILTER_RESET,
  PLANS_AND_SERVICES_FILTER_UPDATED,
  PLANS_AND_SERVICES_FILTER_RESET,
  PLANS_AND_SERVICES_RETIREMENT_PLANS_FILTER_RESET,
  PLANS_AND_SERVICES_RETIREMENT_SERVICES_FILTER_RESET,
  PLANS_AND_SERVICES_TOGGLE_FILTER,
} from '../actions/EbPlansAndServicesActions';

// This is our apps initial state
// Since the initial state should never change, it is wrapped in a function to prevent unintended modification.
const getInitialState = () => {
  return {
    benefitsFilterExpanded: false,
    benefitsServicesFilterExpanded: false,
    retirementPlansFilterExpanded: false,
    retirementServicesFilterExpanded: false,
    // Benefits Plans Filters
    benefitsPlansBrokerFilter: [],
    benefitsPlansCarrierFilter: [],
    benefitsPlansEmployerFilter: [],
    benefitsPlansLobFilter: [],
    benefitsPlansBrokerNormalizedFilter: [],
    benefitsPlansCarrierNormalizedFilter: [],
    // Benefits Services Filters
    benefitsServicesProviderFilter: [],
    benefitsServicesEmployerFilter: [],
    // Retirement Plans Filters
    retirementPlansSponsorFilter: [],
    // Retirement Services Filters
    retirementServicesSponsorFilter: [],
  };
};

function EbPlansAndServicesState(state = getInitialState(), action) {
  switch (action.type) {
    case PLANS_AND_SERVICES_FILTER_UPDATED:
      const { selectedValues, name } = action;
      const newState = { ...state };
      newState[name] = selectedValues;
      return {
        ...newState,
      };
    case PLANS_AND_SERVICES_BENEFITS_FILTER_RESET:
      return {
        ...state,
        benefitsPlansBrokerFilter: [],
        benefitsPlansCarrierFilter: [],
        benefitsPlansEmployerFilter: [],
        benefitsPlansLobFilter: [],
        benefitsPlansBrokerNormalizedFilter: [],
        benefitsPlansCarrierNormalizedFilter: [],
      };
    case PLANS_AND_SERVICES_BENEFITS_SERVICES_FILTER_RESET:
      return {
        ...state,
        benefitsServicesProviderFilter: [],
        benefitsServicesEmployerFilter: [],
      };
    case PLANS_AND_SERVICES_RETIREMENT_PLANS_FILTER_RESET:
      return {
        ...state,
        retirementPlansSponsorFilter: [],
      };
    case PLANS_AND_SERVICES_RETIREMENT_SERVICES_FILTER_RESET:
      return {
        ...state,
        retirementServicesSponsorFilter: [],
      };
    case PLANS_AND_SERVICES_TOGGLE_FILTER:
      const { expanded, filterName } = action;

      if (!filterName) {
        return {
          ...state,
        };
      }
      const newFilterState = { ...state };
      newFilterState[filterName] = expanded;
      return {
        ...newFilterState,
      };
    case PLANS_AND_SERVICES_FILTER_RESET:
      return {
        ...state,
        benefitsPlansBrokerFilter: [],
        benefitsPlansCarrierFilter: [],
        benefitsPlansEmployerFilter: [],
        benefitsPlansLobFilter: [],
        benefitsServicesProviderFilter: [],
        benefitsServicesEmployerFilter: [],
        retirementPlansSponsorFilter: [],
        retirementServicesSponsorFilter: [],
        benefitsPlansBrokerNormalizedFilter: [],
        benefitsPlansCarrierNormalizedFilter: [],
      };
    default:
      return state;
  }
}

export default EbPlansAndServicesState;
